import CategoriesApi from '../../apis/Categories';

export default {
    namespaced: true,
    state: {
        categories: []
    },
    mutations: {
        set_categories (state, data) {
            state.categories = data;
        }
    },
    actions: {
        async getAllCategories ({commit}, filters) {
            return await CategoriesApi.get_all(filters)
                .then( response => {
                    commit('set_categories', response.data)
                })
                .catch( error => {
                    console.log(error);
                })
        }
    }
}